function format(key, credential) {
	switch (key) {
		case 'card':
			return credential.match(/.{1,4}/g).join(' ');
		default:
			return credential;
	}
}

export default format;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-credentials/helpers/format-credential.js